import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import CardContainer from "../CardContainer/index";
import CardBody from "../CardBody/index";
import CardHeader from "../CardHeader/index";
import CardFooter from "../CardFooter/index";
export default function Card(param) {
    var _orientation = param.orientation, orientation = _orientation === void 0 ? 'horizontal' : _orientation, _responsive = param.responsive, responsive = _responsive === void 0 ? true : _responsive, _width = param.width, width = _width === void 0 ? 500 : _width, _height = param.height, height = _height === void 0 ? 500 : _height, headerContent = param.headerContent, bodyContent = param.bodyContent, footerContent = param.footerContent, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, hasBorder = param.hasBorder, elevation = param.elevation;
    return _jsxs(CardContainer, {
        orientation: orientation,
        responsive: responsive,
        width: width,
        height: height,
        isRtl: isRtl,
        hasBorder: hasBorder,
        elevation: elevation,
        children: [
            headerContent && _jsx(CardHeader, {
                cardHeight: height,
                orientation: orientation,
                children: headerContent
            }),
            _jsx(CardBody, {
                orientation: orientation,
                cardHeight: height,
                children: bodyContent
            }),
            footerContent && _jsx(CardFooter, {
                orientation: orientation,
                children: footerContent
            })
        ]
    });
};
